module.exports = __webpack_public_path__ + "img/fastplay_right.1cf24c85.png";